module.exports = __webpack_public_path__ + "static/media/freshgrocer-onboarding-engage.05a96888.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/freshgrocer-onboarding-engage.svg
// module id = 365
// module chunks = 0